<template>
  <div class="main-report">

    <div class="dates-section">
      <div class="date-picker">
        <date-picker
          lang="en"
          placeholder="Start date"
          :disabled-date="notAfterToday"
          v-model="startDate"
          input-class="form-control"
        ></date-picker>
      </div>
      <div class="date-picker">
        <date-picker
          lang="en"
          placeholder="End date"
          :disabled-date="notAfterToday"
          v-model="endDate"
          input-class="form-control"
        ></date-picker>
      </div>
      <button class="generating" @click="getDepRegForChartReport(reportFormat)"><i class="far fa-window-restore"></i> </button>
    </div>

    <div class="btn-group">
      <button class="format-btn" @click="getDepRegForChartReport('Day')">
        Day Format
      </button>
      <button class="format-btn" @click="getDepRegForChartReport('Week')">
        Week Format
      </button>
      <button class="format-btn" @click="getDepRegForChartReport('Month')">
        Month Format
      </button>
      <button class="format-btn" @click="getDepRegForChartReport('Year')">
        Year Format
      </button>
    </div>
    <div class="report-range">
      Report Range: {{ formatDate(startDate) }} -
      {{ formatDate(endDate) }} Format: {{ reportFormat }}
    </div>
    <div v-if="!Array.isArray(report.length) > 0 && !reportBusy">
      <span class="filter-buttons">
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="REG"
            value="REG"
            checked
          />
          <label class="filter-title" for="REG">REG</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="DUP"
            value="DUP"
          />
          <label class="filter-title" for="DUP">DUP</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="ALL"
            value="ALL"
          />
          <label class="filter-title" for="ALL">ALL</label>
        </div>
      </span>
      <table>
        <tr>
          <th>Date</th>
          <th>CTR</th>
          <th>Registered Clients</th>
          <th>Deposited Clients(AMT)</th>
          <th>Deposited Clients(%)</th>
          <th>deposits(AMT)</th>
          <th>deposits(%)</th>
        </tr>
        <tr v-for="(data, key) in report" :key="data">
          <td>{{ key }}</td>
          <td>{{ data[filterOption].CTR }}</td>
          <td>{{ data[filterOption].registered_clients }}</td>
          <td>{{ data[filterOption].deposited_clients.amount }}</td>
          <td>{{ data[filterOption].deposited_clients.percentage }}</td>
          <td>{{ data[filterOption].deposits.amount }}</td>
          <td>{{ data[filterOption].deposits.percentage }}</td>
        </tr>
      </table>
    </div>
    <div class="loader-div" v-if="reportBusy">
      <!--      <loader :size="'8px'"></loader>-->
      <span class="insteadLoader"
        >CREATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import Loader from "../../../../../main/misc.main/loader/Loader";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  name: "DepositRegistrationReportChart.container",
  components: {
    /*Loader,*/
    DatePicker
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      report: [],
      reportBusy: false,
      filterOption: "REG",
      reportFormat: "Day",
      endDate: moment().format("YYYY-MM-DD"),
      startDate: moment()
        .subtract(2, "months")
        .format("YYYY-MM-DD")
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.getDepRegForChartReport(this.reportFormat);
  },
  methods: {
    // async getDepRegForChartReportByDate(from,to){
    //
    // },
    async getDepRegForChartReport(format) {
      this.reportFormat = format;
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/deposits/registration/chart?from_date=${this.formatDate(
              this.startDate
            )}&to_date=${this.formatDate(this.endDate)}&report_format=${format}`
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    notAfterToday(date) {
      return date > moment();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>

<style scoped>
table tr:nth-of-type(2n + 1) {
  background: #f5f7ff;
}
table tr:hover {
  background: #eceff1;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.4em;
}
th {
  font-size: smaller;
}
.main-report {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5em 0;
  flex-direction: column;
}
.filter-buttons {
  padding: 1em 0;
}
.btn-group {
  padding: 1em 0;
}
.format-btn {
  margin: 0 1em;
}
.dates-section {
  display: flex;
}
.date-picker {
  margin: 0 1em;
}
.report-range {
  font-weight: bold;
  padding-top: 1em;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 35%;
  top: 158px;
}
</style>
